module.exports = __webpack_public_path__ + "assets/img/btm-logo.fccb1ce6.png";